<template>
    <div>
        <div class="row">
            <div class="col-lg-6 offset-lg-3 col-12 text-center p-0">
                <div class="card shadow-sm">
                    <div class="card-body">
                    <!-- <p class="h6">สัญญา PDPA ยินยอมส่งข้อมูลผู้กู้ ให้ทางNIM ข้อมูลที่ได้รับมาเป็นข้อมูลที่ได้รับมา อย่างสุจริตและถูกต้อง</p>  -->
                    <img src="/static/img/nimcap/4.png" class="img-fluid" alt="..">
                    <hr>
                    <div class="checkbox">
                          <input 
                          v-model="guarantorConfirmPDPA"
                          type="checkbox"
                                 id="agree"
                                 name="agree"/>
                          <label for="agree" class="mb-0">
                            ข้าพเจ้ายินยอม
                          </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions({
      SET_EL_VALUE: 'nimcap/SET_EL_VALUE'
    }),
    nextPage () {
      this.$emit('next')
    }
  },
  computed: {
    ...mapGetters({
      nimcapDetils: 'nimcap/GET_DETAILS'
    }),
    guarantorConfirmPDPA: {
      get () {
        let state = this.nimcapDetils.guarantorImage.confirmPDPA
        return state
      },
      set (val) {
        let payload = {
          main_key: 'guarantorImage',
          sub_key: 'confirmPDPA',
          value: val
        }
        this.SET_EL_VALUE(payload)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nimcap/Components/Guarantor/Step2.vue